import React from "react";
import { ReviewsSection } from "@/components/ReviewsSection";
import { GoogleReviewsSection } from "@/components/GoogleReviewsSection";
import { Seo } from "@/components/Seo";

export default function Avis() {
  return (
    <div data-testid="avis-page">
      <Seo
        title="Avis clients — Work & Travel Expert | Australie & Canada"
        description="Découvrez les avis de nos clients accompagnés vers l'Australie et le Canada, et partagez votre propre expérience avec Work & Travel Expert."
        keywords="avis work travel expert, témoignages clients immigration australie canada"
        path="/avis"
      />
      <div className="relative bg-navy overflow-hidden">
        <div className="pointer-events-none absolute -top-40 -right-24 w-[34rem] h-[34rem] rounded-full bg-gold/15 blur-[120px]" />
        <div className="relative z-10 max-w-6xl mx-auto px-5 sm:px-8 py-16 sm:py-20 text-center">
          <span className="inline-block text-xs sm:text-sm uppercase tracking-[0.25em] text-gold font-semibold">Témoignages</span>
          <h1 className="mt-4 font-heading font-medium text-white text-4xl sm:text-5xl lg:text-6xl">Ce que disent nos clients</h1>
          <p className="mt-5 max-w-2xl mx-auto text-white/80 text-base sm:text-lg leading-relaxed">
            La satisfaction de nos candidats est notre plus belle récompense. Lisez leurs retours et partagez le vôtre.
          </p>
        </div>
      </div>
      <GoogleReviewsSection theme="light" />
      <ReviewsSection />
    </div>
  );
}
